export enum PoiGeometryType {
    POINTS = 0,
    FACES = 1
}
